// extracted by mini-css-extract-plugin
module.exports = {"form":"_normal--form--3LWbl","divider":"_normal--divider--1V5uw"};